export default __webpack_public_path__ + "static/media/safe7-intro-zh-hant.c9abd149.png";